import Card, { ICardProps } from '../card/card';

export interface IInnsworthListProps {
    cards: Array<ICardProps>;
}

export default function InnsworthList(props: IInnsworthListProps) {

    return (
        <div className='list-container'>
            {props.cards.map((card: ICardProps, idx: number) => ( <Card key={idx} {...card} />))}
        </div>
    );
}